export default {
    add_patient: "Додати пацієнта",
    add_task: "Додати задачу",
    calls: "Дзвінки",
    chat_panel: "Панель чатів",
    clinic_id: "Id клініки",
    confirm: "Підтвердити",
    expenses: "Витрати",
    high: "Висока",
    low: "Низька",
    medium: "Середня",
    no_notifications: "Повідомлень немає",
    read_all: "Прочитано все",
    remove_confirmation: "Скасувати підтвердження",
    tasks: "Задачі"
}
